import { render, staticRenderFns } from "./product-detail-tab3.vue?vue&type=template&id=1e1de170&scoped=true&"
import script from "./product-detail-tab3.vue?vue&type=script&lang=tsx&"
export * from "./product-detail-tab3.vue?vue&type=script&lang=tsx&"
import style0 from "./product-detail-tab3.vue?vue&type=style&index=0&id=1e1de170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1de170",
  null
  
)

export default component.exports